import React from 'react';

import styled from 'styled-components';

import { CmiDigestWatchlistSupportingContextItem } from 'types/cmiDigestWatchlist';

import { Column, ColumnTitle, EmptyMessage } from './DigestSectionLayout';

const Item = styled.div`
  & + & {
    margin-top: 15px;
  }
`;

const Label = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Value = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: var(--text-secondary);
`;

type Props = {
  items: CmiDigestWatchlistSupportingContextItem[];
};

const NotableItemsColumn = ({ items }: Props) => (
  <Column data-test-id="weekly-digest-notable-items">
    <ColumnTitle>Notable Items</ColumnTitle>
    {items.length === 0 && <EmptyMessage>No notable items in this digest.</EmptyMessage>}
    {items.map((item) => (
      <Item key={item.label}>
        <Label>{item.label}</Label>
        <Value>{item.value}</Value>
      </Item>
    ))}
  </Column>
);

export default NotableItemsColumn;
